import { render, staticRenderFns } from "./ShowSaleCartable.vue?vue&type=template&id=438530b1&"
import script from "./ShowSaleCartable.vue?vue&type=script&lang=js&"
export * from "./ShowSaleCartable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports